import { z } from 'zod';

import { idSchema } from './id';

export const personSchema = z.object({
    id: idSchema,
    emailAddress: z.string().optional(),
    firstName: z.string(),
    lastName: z.string(),
});

export type Person = z.infer<typeof personSchema>;

export const personsSchema = personSchema.array();

export type Persons = z.infer<typeof personsSchema>;
